"use client";

import React from "react";
import { motion } from "framer-motion";
import FAQ from "@/components/patient-info/FAQ";
import { faqData } from "@/lib/faq-data";
import BeginJourney from "@/components/shared/BeginJourney";

const FAQPage = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50"
      data-oid="ham8i8q"
    >
      {/* Hero Section */}
      <section
        className="bg-gradient-to-r from-brand-blue/10 to-brand-pink/10 py-16"
        data-oid="_b7s-rc"
      >
        <div className="max-w-3xl mx-auto text-center" data-oid="-hb03w6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            data-oid="_r.wsxd"
          >
            <h1
              className="mb-6 text-4xl md:text-5xl font-bold text-brand-blue"
              data-oid="al-i4wn"
            >
              Frequently Asked Questions
            </h1>
            <p
              className="mt-3 max-w-md mx-auto text-xl text-gray-500 sm:text-2xl md:mt-5 md:max-w-3xl"
              data-oid="h7inkmv"
            >
              Find answers to common questions about fertility treatments and
              our services.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" data-oid="lxomzwq">
        <div className="max-w-4xl mx-auto" data-oid="m4p8.mq">
          <FAQ faqs={faqData} data-oid="m21cd0x" />
        </div>
      </section>

      {/* Begin Journey Section */}
      <BeginJourney
        description="Have more questions? Book a consultation to discuss your fertility journey with our expert team."
        data-oid="xk8x3ea"
      />
    </div>
  );
};

export default FAQPage;
